import { createAction } from '@ngrx/store';
import { createEntityEvent } from '../../../shared/base';

export const AssignedResidentToBuildingEvent = createEntityEvent('AssignedResidentToBuildingEvent');

